import { Enums } from '../enums';

export const parseVoid = message => {
  const hexMessage = message.toString('hex');
  const fields = hexMessage.split('2c').map(field => {
    return Buffer.from(field, 'hex').toString();
  });

  if (fields[0] !== '03') {
    throw new Error('Void tag is not 03, wrong tag or out of order fields.');
  }

  const response = {};

  fields.forEach((value, i) => {
    const Enum = Enums.responses.voidRes[i];
    if (!Enum) {
      response.unknown = value;
      return;
    }
    const { field } = Enum;
    logger.log(`[marshal] parseVoid: parsing field [${field}] with value [${value}]`);
    response[field] = value;
  });

  return response;
};
